import { css } from '@emotion/core';
export const prefixContainer = css `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  pointer-events: none;
`;
export const prefix = css `
  display: inline-block;
  position: relative;
  height: 100%;
  width: 1em;

  &::before {
    display: inline-block;
    z-index: -1;
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
  }
`;
export const listItemPrefix = css `
  ${prefix}

  &::before {
    left: 25%;
    width: 1px;
  }
`;
export const blockQuotePrefix = css `
  ${prefix}

  &::before {
    left: 0;
    width: 25%;
  }
`;
//# sourceMappingURL=styles.js.map